import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ee5af7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colSingle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Скопировать данные из", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 ModelField-colSingle" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_8 = { class: "card card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-2 ModelField-colFirst" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_12 = { class: "col-2 ModelField-col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_14 = { class: "col-2 ModelField-colLast" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-4 ModelField-colFirst" }
const _hoisted_18 = { class: "ModelField-label" }
const _hoisted_19 = {
  key: 0,
  class: "col-4 ModelField-colLast"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес нетто (кг)", -1))
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-4 ModelField-colFirst" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заказ", -1))
const _hoisted_24 = { class: "col-4 ModelField-col" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отклонение (-)", -1))
const _hoisted_26 = { class: "col-4 ModelField-colLast" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отклонение (+)", -1))
const _hoisted_28 = {
  key: 2,
  class: "row"
}
const _hoisted_29 = { class: "col-2 ModelField-colSingle" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Порядок погрузки", -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-2 ModelField-colFirst" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Количество (шт)", -1))
const _hoisted_34 = { class: "col-4 ModelField-colLast" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тоннаж (кг)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CheckBoxControl = _resolveComponent("CheckBoxControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    maxWidth: "1000px",
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.cargoId,
                "onUpdate:id": ($event: any) => ((model.cargoId) = $event),
                desc: model.cargoDescription,
                "onUpdate:desc": ($event: any) => ((model.cargoDescription) = $event),
                keyField: "id",
                displayDescField: "name",
                catalogueComponentName: "catalogues/CargoPallet/CargoPalletCatalogue",
                hasEmptyValue: true,
                validationGroup: validationGroup,
                onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange()))
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Длина...",
                min: 0,
                value: model.length,
                "onUpdate:value": ($event: any) => ((model.length) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Ширина...",
                min: 0,
                value: model.width,
                "onUpdate:value": ($event: any) => ((model.width) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота...",
                min: 0,
                value: model.height,
                "onUpdate:value": ($event: any) => ((model.height) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.separationWeight ? "Вес брутто (кг)" : "Вес (кг)"), 1),
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Вес брутто...",
                decimalPoints: 3,
                min: 0,
                value: model.weight,
                "onUpdate:value": ($event: any) => ((model.weight) = $event),
                onChanged: _cache[1] || (_cache[1] = ($event: any) => {
                  _ctx.calcWeightSum();
                  _ctx.setWeight2();
                }),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            (_ctx.separationWeight)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_DecimalControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Вес нетто...",
                    decimalPoints: 3,
                    min: 0,
                    value: model.weight2,
                    "onUpdate:value": ($event: any) => ((model.weight2) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.hasOrder)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_TextControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Заказ...",
                    "show-clear-button": true,
                    value: model.orderDescription,
                    "onUpdate:value": ($event: any) => ((model.orderDescription) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_DecimalControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Отклонение (-)...",
                    decimalPoints: 1,
                    min: 0,
                    value: model.marginMin,
                    "onUpdate:value": ($event: any) => ((model.marginMin) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_DecimalControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Отклонение (+)...",
                    decimalPoints: 1,
                    min: 0,
                    value: model.margin,
                    "onUpdate:value": ($event: any) => ((model.margin) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasCargoPriority)
            ? (_openBlock(), _createBlock(_component_CheckBoxControl, {
                key: 1,
                class: "PlanCargoRoll-checkbox",
                value: model.highPriority,
                "onUpdate:value": ($event: any) => ((model.highPriority) = $event),
                text: "Обязательно для погрузки"
              }, null, 8, ["value", "onUpdate:value"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CheckBoxControl, {
            class: "PlanCargoRoll-checkbox",
            value: model.isPile,
            "onUpdate:value": ($event: any) => ((model.isPile) = $event),
            text: "Кипа"
          }, null, 8, ["value", "onUpdate:value"]),
          (_ctx.hasCargoQueue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_IntegerControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "порядок...",
                    min: 0,
                    value: model.queuePosition,
                    "onUpdate:value": ($event: any) => ((model.queuePosition) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Количество...",
                min: 0,
                value: model.count,
                "onUpdate:value": ($event: any) => ((model.count) = $event),
                onChanged: _ctx.calcWeightSum,
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "onChanged", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "тоннаж...",
                decimalPoints: 3,
                min: 0,
                readOnly: "",
                value: model.totalWeight,
                "onUpdate:value": ($event: any) => ((model.totalWeight) = $event),
                onChanged: _ctx.calcCount
              }, null, 8, ["value", "onUpdate:value", "onChanged"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}